// extracted by mini-css-extract-plugin
module.exports = {"styles":"_3YIt46T6nIn9TQvDd9h7mG"};